import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {SrcMappingContract} from "../../../model/mapping/src-mapping-contract";
import {MappingSrcMappingContractService} from "../../../services/mapping/mapping-src-mapping-contract.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-mapp-contract',
  templateUrl: './src-mapping-contract.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class SrcMappingContractComponent extends CrudBaseComponent<SrcMappingContract> {

  //fields
  sources: FieldRecord<any>[];
  exchanges: FieldRecord<any>[];
  contracts: FieldRecord<any>[] = [];
  currentContractsRequest: FieldRequest;
  contractTypes: FieldRecord<any>[];

  constructor(cdref: ChangeDetectorRef,
              crudService: MappingSrcMappingContractService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = crudService;
    this.newRecord = new SrcMappingContract();
    this.newRecord.id = -1;
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.id = -1;
      this.formRecord.sourceContractCode = undefined;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'sourceCode',
        width: 130
      },
      {
        field: 'crystalExchangeCode',
        width: 130,
        icon: (record: any) => {
          const exchField = this.exchanges ? this.exchanges.find(field => field.value
            && field.value.code === record.crystalExchangeCode) : undefined;
          if (exchField && exchField.value) {
            return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          } else {
            return 'fas fa-globe-europe';
          }
        }
      },
      {
        field: 'crystalContractCode',
        width: 130
      },
      {
        field: 'crystalContractType',
        width: 130
      },
      {
        field: 'sourceContractCode',
        width: 130
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'sourceCode',
            required: true,
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.sources,
          },
          {
            field: 'crystalExchangeCode',
            required: true,
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.exchanges,
            icon: (ig: any) => {
              const exchField = this.exchanges ? this.exchanges.find(field => field.value && field.value.code === ig) : undefined;
              if (exchField && exchField.value) {
                return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              } else {
                return 'fas fa-globe-europe';
              }
            }, changed: event => {
              this.formRecord.crystalExchangeCode = event.value;
              this.formRecord.crystalContractCode = undefined;
              this.filterContracts();
            }
          },
          {
            field: 'crystalContractCode',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.contracts,
            optionValue: 'text',
            icon: (id: string) => {
              const contractField = this.contracts.find(field => field.id === id);
              if (contractField) {
                if (contractField.id.endsWith('-F'))
                  return 'cc-ico cc-ico-future';
                else if (contractField.id.endsWith('-O'))
                  return 'cc-ico cc-ico-option';
                else if (contractField.id.endsWith('-S'))
                  return 'cc-ico cc-ico-stock';
              }
              return '';
            },
            changed: event => {
              const contract = this.contracts.find(field => field.value.code == this.formRecord.crystalContractCode);
              if (contract)
                this.formRecord.crystalContractCode = contract.value.code;
            }
          },
          {
            field: 'sourceContractCode',
            required: true,
            column: 4,
            type: TYPE.TEXT
          },
          {
            field: 'crystalContractType',
            required: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.contractTypes
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.commonFieldService.getSources(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.sources = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 3;
    });

    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 3;
      this.filterContracts();
    });

    this.contractTypes = [];
    for (let key in SrcMappingContract.ContractType) {
      this.contractTypes.push(new FieldRecord(key, key.toLowerCase()))
    }

  }

  onFormShow() {
    this.filterContracts();
  }


  private filterContracts() {
    if (this.formRecord && this.formRecord.crystalExchangeCode) {
      // const exchangeField = this.exchanges.find(value => value.id == this.formRecord.crystalExchangeCode);
      // if (exchangeField) {
      const newRequest = new FieldRequest(undefined, this.formRecord.crystalExchangeCode);
      // newRequest.search3 = [this.formRecord.crystalExchangeCode]
      if (!this.currentContractsRequest || this.currentContractsRequest.search != newRequest.search
        || this.currentContractsRequest.search2 != newRequest.search2) {
        this.formLoading = true;
        this.currentContractsRequest = newRequest;
        // console.log("-------> newRequest " + JSON.stringify(newRequest));
        this.commonFieldService.getContracts(this.currentContractsRequest).subscribe(fieldResult => {
            const contractsFields = this.getFields(fieldResult);
            this.contracts = contractsFields ? contractsFields.filter(field => field.value.id.endsWith('-F')) : [];
            // console.log("-------> contractsFields " + JSON.stringify(this.contracts));
            if (this.settingsFormLoadingProgressValue < 100) {
              this.settingsFormLoadingProgressValue += 100 / 3;
            }
            this.initConfigs();
            this.formLoading = false;
          }
        );
      }
    } else {
      if (this.settingsFormLoadingProgressValue < 100) {
        this.settingsFormLoadingProgressValue += 100 / 3;
      }
    }
    // }
  }

}
